import React from 'react';
import { Helmet } from 'react-helmet';

function Complaint_Policy_Seo() {
    return (
        <div>
            <Helmet>
                <title>Complaints Policy | FinestPay</title>
                <meta name="description" content="We are regulated by FCA and HMRC in the UK. We are have to help if you have any compliants. Contact us if you want to discuss your recent experience." />
                <meta property="og:title" content="Complaints Policy | FinestPay" />
                <meta property="og:description" content="We are regulated by FCA and HMRC in the UK. We are have to help if you have any compliants. Contact us if you want to discuss your recent experience." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/complaint-policy"/>
            </Helmet>
        </div>
    )
}

export default Complaint_Policy_Seo
